export const getLensRadius = (width: number, height: number): number => {
    if (width < 768) return Math.min(width * 0.36, height * 0.2)

    return Math.min(height * 0.28, width * 0.24)
}

export const getCoverRadius = (width: number, height: number): number => {
    return Math.hypot(width, height) / 2 + 24
}

export const easeInCubic = (value: number): number => value * value * value

export const easeOutCubic = (value: number): number => 1 - Math.pow(1 - value, 3)

export const easeInOutCubic = (value: number): number => {
    return value < 0.5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2
}
